/**
 * Manages a queue of quick temporary notifications.
 * Each notification fades out before being removed from the queue.
 */
import _ from 'lodash';
import { QUICK_MESSAGE_ENQUEUE, QUICK_MESSAGE_FADE, QUICK_MESSAGE_DEQUEUE } from './actions';
import { quickMessageDuration, quickMessageFadeOutDuration } from '../../theme/uiConfig';

const initialState = {};

export default (state = initialState, action) => {

	let quickMessages = _.cloneDeep(state);

	switch (action.type) {

		case QUICK_MESSAGE_ENQUEUE:
			quickMessages[action.key] = {
				message: action.message,
				created: action.created
			};
			return quickMessages;

		case QUICK_MESSAGE_FADE:
			quickMessages[action.key].fading = true;
			return quickMessages;

		case QUICK_MESSAGE_DEQUEUE:
			delete quickMessages[action.key];
			return quickMessages;

		default:
			return state;
	}

};

/**
 * Enqueues a new quick message and schedules its fading and dequeue.
 * @param {string} message
 */
export const showQuickMessage = (message) => {
	return dispatch => {
		// creation date will be used to determine the display order, since we are storing in an object
		let created = (new Date()).getTime();
		// it's important to create an unique key here, this will be used as React's key
		let key = created.toString(36) + Math.random().toString(36).substr(2, 5);
		dispatch({
			type: QUICK_MESSAGE_ENQUEUE,
			message,
			created,
			key
		});
		setTimeout(() => {
			dispatch({
				type: QUICK_MESSAGE_FADE,
				key
			});
		}, quickMessageDuration - quickMessageFadeOutDuration);
		setTimeout(() => {
			dispatch({
				type: QUICK_MESSAGE_DEQUEUE,
				key
			});
		}, quickMessageDuration);
	};
};


// WEBPACK FOOTER //
// ./src/redux/modules/quickMessages.js